'use client'

import { EmailSidebarMatterSearchAndSelect } from '@repo/ui/EmailSidebarMatterSearchAndSelect'
import { useEffect, useState } from 'react'
import { useEmailCardStore } from '@repo/store/useEmailCardStore'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'
import { useMattersStore } from '@repo/store/useMattersStore'
import MUIStack from '@mui/material/Stack'

type EmailSidebarMatterCardProps = {
  testData?: boolean
  locked?: boolean
}

export const EmailSidebarMatterCard = ({ testData = false, locked = false }) => {
  const { isOutlookAddin } = useGlobalSettingsStore()
  const { currentClientMatterNo, matters } = useMattersStore()
  const [isCurrentMatter, setIsCurrentMatter] = useState(currentClientMatterNo !== null ? true : false)
  const { emailSendingCurrentMatterData, setEmailSendingCurrentMatterData, resetEmailSendingCurrentMatterData } =
    useEmailCardStore()
  const { clientNo = null, matterNo = null } =
    !isOutlookAddin && matters && currentClientMatterNo && matters[currentClientMatterNo]
      ? matters[currentClientMatterNo]
      : {}

  useEffect(() => {
    if (testData) return

    const isCurrentMatter = currentClientMatterNo === emailSendingCurrentMatterData.clientMatterNo
    setIsCurrentMatter(isCurrentMatter)

    if (
      (emailSendingCurrentMatterData.clientNo === null || emailSendingCurrentMatterData.matterNo === null) &&
      currentClientMatterNo &&
      isCurrentMatter === true
    ) {
      setEmailSendingCurrentMatterData({
        clientMatterNo: currentClientMatterNo,
        clientNo: matters[currentClientMatterNo].clientNo,
        dateArchived: matters[currentClientMatterNo].dateArchived,
        feeEarnerDescription: matters[currentClientMatterNo].feeEarnerDescription,
        forename: matters[currentClientMatterNo].forename,
        highRisk: matters[currentClientMatterNo].highRisk,
        isArchived: matters[currentClientMatterNo].archiveReference,
        isUserRestricted: matters[currentClientMatterNo].isUserRestricted,
        matterDescription: matters[currentClientMatterNo].matterDescription,
        matterNo: matters[currentClientMatterNo].matterNo,
        surname: matters[currentClientMatterNo].surname,
        workTypeId: matters[currentClientMatterNo].workflowTypeId
      })
      console.log(`EmailSidebarMatterCard: Setting current matter to ${currentClientMatterNo}`)
    }
  }, [currentClientMatterNo, matters, setEmailSendingCurrentMatterData, emailSendingCurrentMatterData])

  return (
    <MUIStack
      data-testid="EmailSidebarMatterCard"
      id={'matterCard'}
      sx={{ mb: 2, ...(locked ? { pointerEvents: 'none', opacity: 0.8 } : {}) }}
    >
      <EmailSidebarMatterSearchAndSelect
        testData={testData}
        selectedMatter={emailSendingCurrentMatterData.clientMatterNo ? emailSendingCurrentMatterData : null}
        onSelect={locked ? undefined : setEmailSendingCurrentMatterData}
        onClear={locked ? undefined : resetEmailSendingCurrentMatterData}
      />
    </MUIStack>
  )
}
